<template>
  <i18n-t
    scope="global"
    keypath="components.home.almaPill.payInInstalments"
    tag="p"
    class="text-xs font-medium text-text-primary-inverse"
  >
    <template #logo>
      <SvgoCommonAlmaLogoWhite
        class="inline h-2.5 w-auto -translate-y-px align-middle"
        filled
        :font-controlled="false"
        role="img"
        :aria-label="$t('components.home.almaPill.almaLogo')"
      />
    </template>
  </i18n-t>
</template>
